function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgZutoLogoExperimentalinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 89.16,
  height: 32
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M74.8 1.96A3.739 3.739 0 0 0 72.48 1H1.36A1.348 1.348 0 0 0 0 2.36v29.36A1.391 1.391 0 0 0 1.36 33h71.12a3.364 3.364 0 0 0 2.24-.96L88.8 17.96a1.459 1.459 0 0 0 0-1.92z",
  style: {
    fill: "#6b676f"
  },
  transform: "translate(0 -1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.64 22.68 8.56-10.24H6.56v-6h17.52v4.88L15.6 21.56h8.96v6H6.64zm20.4-11.84h6.56v11.12c0 .8.32 1.36 1.2 1.36a2.853 2.853 0 0 0 2-1.2V10.84h6.56v16.72H37.2l-.4-1.76a6.7 6.7 0 0 1-4.64 2.16c-3.76 0-5.12-2.08-5.12-6.16zm25.28-4.4h-6.48v15.12c0 4.4 1.68 6.32 5.68 6.32a11.656 11.656 0 0 0 5.76-1.76l-1.92-3.92a6.213 6.213 0 0 1-1.92.56c-.72 0-1.12-.4-1.12-1.36v-6.32h3.92v-4.24h-3.92zm14.16 16.88c1.44 0 2.16-1.6 2.16-4.16 0-2.4-.72-4-2.16-4s-2.16 1.6-2.16 4c-.08 2.56.64 4.16 2.16 4.16zm8.72-4.24a8.383 8.383 0 0 0-8.72-8.64c-5.04 0-8.8 3.52-8.72 8.64 0 5.52 3.52 8.88 8.72 8.88s8.72-3.44 8.72-8.88z",
  style: {
    fill: "#ffed00",
    fillRule: "evenodd"
  },
  transform: "translate(0 -1)"
}));
export default SvgZutoLogoExperimentalinline;